<template>
  <div class="changeBg">
    <div class="wrp">
      <div class="ant-upload ant-upload-drag main-col flex-center">
        <div
          v-if="colors.length > 0"
          class="img-wrap"
          :style="{...colors.length > 0 ? {backgroundImage:`linear-gradient(to bottom,#${colors[colorsIdx].s_color},#${colors[colorsIdx].e_color})`}:{}}"
        >
          <!-- colors.length > 0 ? `background-image:linear-gradient(to bottom,#${colors[colorsIdx].s_color},#${colors[colorsIdx].e_color})`:'' -->
          <img :src="url" ondragstart="return false;" class="upload-img" alt />
        </div>
      </div>
      <div class="sidebar-col">
        <sideBar title="保存" iconType="download">
          <div class="sidebar-con">
            <a-button @click="showPayPopFn" class="btn" type="primary" block>保存</a-button>
            <router-link :to="{ path: '/changeBgIdx' }">
              <a-button class="btn" block>重新上传</a-button>
            </router-link>
          </div>
        </sideBar>
        <sideBar title="背景色" iconType="copy">
          <div class="sidebar-con">
            <selColor :colors="colors" :colorsIdx="colorsIdx" :changeIdx="changeIdx"></selColor>
          </div>
        </sideBar>
      </div>
    </div>
    <payPop
      v-if="showPayPop"
      picType="base_map"
      :cancel="cancel"
      :isFormal="false"
      :isChangeBg="true"
      :colors="colors"
      :colorsIdx="colorsIdx"
      :isVisible="showPayPop"
    ></payPop>
  </div>
</template>

<script>
// @ is an alias to /src
import sideBar from "@/components/sidebar.vue";
import selColor from "@/components/selColor.vue";
import payPop from "@/components/payPop.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showPayPop: false,
      colorsIdx: 0,
      url: sessionStorage.getItem("url")
    };
  },
  metaInfo() {
    return {
      title: "证件照换底色在线制作丨证件照换底色+一寸证件照制作",
      meta: []
    };
  },
  computed: mapState({ colors: state => state.colors }),
  components: {
    sideBar,
    selColor,
    payPop
  },
  beforeCreate() {
    if (!sessionStorage.getItem("url")) {
      this.$router.replace(`/changeBgIdx`);
    }
  },
  methods: {
    showPayPopFn() {
      this.showPayPop = true;
    },
    changeIdx(idx) {
      this.colorsIdx = idx;
    },
    cancel() {
      this.showPayPop = false;
    }
  }
};
</script>
<style scoped>
.sidebar-con {
  padding: 14px 15px;
}
.img-wrap {
  max-width: 80%;
  /* height: 80%; */
  width: 409px;
  height: auto;
  max-height: 80%;
  display: inline-block;
}
.upload-img {
  width: 100%;
  max-height: 100%;
}
.btn {
  height: 40px;
  margin-bottom: 8px;
}
.btn:last-child {
  margin-bottom: 0;
}
</style>
